import React from 'react';
import { reportError } from './stackdriverErrorReporter';

export const withStoppedPropagation = <T>(
  fn: (e: React.SyntheticEvent) => T,
  preventDefault = true
): ((e: React.SyntheticEvent) => T) => {
  return (e: React.SyntheticEvent) => {
    e.stopPropagation();
    if (preventDefault) {
      e.preventDefault();
    }
    return fn(e);
  };
};

export const wait = (milliseconds: number): Promise<{}> =>
  new Promise((resolve) => setTimeout(resolve, milliseconds));

export const fireAndForget = async (
  fn: () => Promise<any>,
  waitMs = 2000,
  options?: { ignoreError?: boolean }
) => {
  const opts = {
    ...options,
    ignoreError: false
  };
  // tslint:disable-next-line
  fn();
  try {
    await wait(waitMs);
  } catch (err: any) {
    reportError(err);
    if (!opts.ignoreError) {
      throw err;
    }
  }
};
